import { useState } from "react";
import "./Footer.scss";
import { ReactComponent as TW } from "../../../assets/images/tradingview-logo.svg";
import { useTranslation } from "react-i18next";
import { FooterTimer } from "./FooterTimer";
import Feedback from "../Feedback/Feedback";
import RequestVoting from "../RequestVoting/RequestVoting";
import { useAppSelector } from "../../../services/hooks.service";
import { ModalApp } from "../ModalApp/ModalApp";

const Footer = ({ className }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const reportButtons = useAppSelector((state) => state.settings.reportButtons);

  return (
    <>
      <div className={`footer ${className}`}>
        <FooterTimer />
        { reportButtons && <div className="footer_btns">
          <Feedback />
          <RequestVoting />
        </div> }
        <button className="tw_cont" onClick={() => setShowModal(true)}> 
          {t("tradeChart.charts_by")} <TW />
        </button>
      </div>
      
      <ModalApp
        show={showModal} 
        onHide={() => setShowModal(false)} 
        title={<span className="twlogo_cont"><TW /></span>}
        width={380}
      >
        {t("tradeChart.provided_by_txt")}
        <a href="https://www.tradingview.com/markets/cryptocurrencies/global-charts/" target="blank" className="link">
          {t("tradeChart.crypto_market_cap")}
        </a>
        {t("tradeChart.provided_by_txt_2")}
      </ModalApp>
    </>
  );
};

export { Footer };
